export const platform = {
  'platform.title': 'المدارس',
  'platform.subtitle': 'إدارة المنصّة: المدارس والاشتراكات والميزات',
  'platform.count': '{n}',
  'platform.newSchool': 'مدرسة جديدة',
  'platform.activationCode': 'رمز تفعيل',
  'platform.col.school': 'المدرسة',
  'platform.col.country': 'الدولة',
  'platform.col.currency': 'العملة',
  'platform.col.status': 'الحالة',
  'platform.col.created': 'تاريخ الانضمام',
  'platform.empty': 'لا مدارس بعد',
  'platform.emptyBody': 'أنشئ أول مدرسة مع مديرها وسنتها الدراسية.',
  'platform.search': 'ابحث باسم المدرسة',
  'platform.open': 'فتح',
  'platform.status.TRIAL': 'تجريبي',
  'platform.status.ACTIVE': 'فعّال',
  'platform.status.READ_ONLY': 'قراءة فقط',
  'platform.status.SUSPENDED': 'موقوف',
  'platform.statusHelp.TRIAL': 'فترة تجريبية: كل شيء يعمل كالاشتراك الفعّال.',
  'platform.statusHelp.ACTIVE': 'اشتراك مدفوع: كل شيء يعمل.',
  'platform.statusHelp.READ_ONLY': 'توقف الدفع: الإدارة تطّلع دون حفظ أي تعديل، وأولياء الأمور يستمرون بالاطلاع.',
  'platform.statusHelp.SUSPENDED': 'موقوفة: لا يدخل أحد من المدرسة حتى تُعاد.',
  'platform.create.title': 'مدرسة جديدة',
  'platform.create.description': 'تُنشأ المدرسة مع صفوف دولتها وسنة دراسية حالية وصندوق نقدي وحساب مصرفي وحساب لمديرها.',
  'platform.create.school': 'بيانات المدرسة',
  'platform.create.name': 'اسم المدرسة بالعربية',
  'platform.create.nameEn': 'اسم المدرسة بالإنجليزية',
  'platform.create.country': 'الدولة',
  'platform.create.rounding': 'وحدة التقريب',
  'platform.create.roundingHint': 'الافتراضي: ١٠٠٠ للعراق و١ لليبيا',
  'platform.create.loginGrade': 'دخول الطلاب من الصف',
  'platform.create.loginGradeDefault': 'الافتراضي: {grade}',
  'platform.create.structure': 'المراحل والصفوف',
  'platform.create.structureHint': 'تُنسخ هذه الصفوف إلى المدرسة الجديدة، ويستطيع مديرها تعديل أسمائها أو إخفاء ما لا تدرّسه.',
  'platform.create.nationalExam': 'وزاري',
  'platform.create.streams': 'الفروع',
  'platform.create.timeZone': 'المنطقة الزمنية',
  'platform.create.cap': 'حد استقطاع السلف من الراتب',
  'platform.create.capHigh': '{rate} من الأجر، و{high} إذا تجاوز {times} أضعاف الحد الأدنى',
  'platform.create.year': 'السنة الدراسية الأولى',
  'platform.create.yearName': 'اسم السنة',
  'platform.create.yearStart': 'البداية',
  'platform.create.yearEnd': 'النهاية',
  'platform.create.endBeforeStart': 'يجب أن تكون النهاية بعد البداية',
  'platform.create.manager': 'مدير المدرسة',
  'platform.create.managerName': 'اسم المدير',
  'platform.create.managerPhone': 'هاتف المدير',
  'platform.create.submit': 'إنشاء المدرسة',
  'platform.create.done': 'أُنشئت {name}',
  'platform.create.nextStep': 'الخطوة التالية: أعطِ المدير رمز تفعيل ليعيّن كلمة المرور.',
  'platform.create.giveCode': 'إنشاء رمز للمدير',
  'platform.detail.back': 'كل المدارس',
  'platform.detail.notFound': 'لم تُعثر على هذه المدرسة',
  'platform.detail.status': 'حالة المدرسة',
  'platform.detail.statusHint': 'تُطبَّق فوراً على كل مستخدمي المدرسة.',
  'platform.detail.changeStatus': 'تغيير الحالة',
  'platform.detail.statusTitle': 'تغيير حالة {name} إلى «{status}»؟',
  'platform.detail.statusChanged': 'تغيّرت حالة المدرسة',
  'platform.detail.current': 'الحالية',
  'platform.detail.features': 'ميزات المدرسة',
  'platform.detail.featuresHint': 'تتحكم المنصّة بالميزات الأساسية، ويمكنك أيضاً تغيير ما يتحكم به مدير المدرسة عند الحاجة.',
  'platform.detail.members': 'المستخدمون',
  'platform.detail.membersHint': 'أضف مالكاً أو مديراً أو محاسباً، ثم أعطه رمز تفعيل ليعيّن كلمة المرور.',
  'platform.detail.addMember': 'إضافة مستخدم',
  'platform.detail.memberAdded': 'أُضيف {name} بدور {role}',
  'platform.detail.facts': 'بيانات المدرسة',
  'platform.member.name': 'الاسم الكامل',
  'platform.member.phone': 'رقم الهاتف',
  'platform.member.role': 'الدور',
  'platform.code.title': 'رمز تفعيل',
  'platform.code.description': 'رمز من ٦ أرقام يعيّن به الشخص كلمة المرور من «أول مرة أو نسيت كلمة المرور؟». يصله برسالة SMS أو تعطيه له بنفسك، ويُسجَّل كل رمز.',
  'platform.code.phone': 'رقم الهاتف',
  'platform.code.country': 'الدولة',
  'platform.code.purpose': 'الغرض',
  'platform.code.purpose.SET_PASSWORD': 'أول دخول',
  'platform.code.purpose.RESET_PASSWORD': 'إعادة تعيين كلمة المرور',
  'platform.code.generate': 'إنشاء الرمز',
  'platform.code.another': 'رمز آخر',
  'platform.code.forPhone': 'الرمز لـ',
  'platform.code.expires': 'ينتهي {time}',
  'platform.code.validFor': 'صالح لمدة {n}',
  'platform.code.expired': 'انتهت صلاحية الرمز؛ أنشئ رمزاً جديداً.',
  'platform.code.copy': 'نسخ الرمز',
  'platform.code.copied': 'نُسخ الرمز',
  'platform.code.copyFailed': 'تعذّر النسخ؛ حدّد الرمز وانسخه يدوياً.',
  'platform.code.noAccount': 'لا يوجد حساب فعّال بهذا الرقم. أضف الشخص إلى مدرسة أولاً، أو تحقق من الرقم والدولة.',
  'platform.code.oneUse': 'يُستخدم الرمز مرة واحدة. لا ترسله في مجموعات أو رسائل عامة.',
  'platform.code.validForHours': 'صالح لمدة {n}',
  'platform.col.students': 'الطلاب',
  'platform.col.staff': 'الموظفون',
  'platform.memberStatus.SUSPENDED': 'موقوف',
  'platform.memberStatus.REVOKED': 'ملغى',
  'platform.memberStatus.ACTIVE': 'فعّال',
  'platform.code.delivery': 'طريقة الإيصال',
  'platform.code.delivery.SMS': 'رسالة SMS',
  'platform.code.delivery.MANUAL': 'أعطيه الرمز بنفسي',
  'platform.code.noSms': 'لا تتوفر رسائل SMS في {country} بعد، لذلك ستعطي الرمز للشخص بنفسك.',
  'platform.code.note': 'السبب',
  'platform.code.notePlaceholder': 'مثلاً: لم تصل رسالة الرمز',
  'platform.code.noteHint': 'يظهر في سجل رموز التفعيل.',
  'platform.code.send': 'إرسال الرمز',
  'platform.code.sentTitle': 'أُرسل الرمز برسالة',
  'platform.code.sentBody': 'يفتح صاحب الحساب «أول مرة أو نسيت كلمة المرور؟» ويُدخل الرمز من الرسالة. الرمز صالح ٢٤ ساعة.',
  'platform.code.failedTitle': 'لم تُرسل الرسالة',
  'platform.code.failedBody': 'ردّ مزوّد الرسائل:',
  'platform.code.manualInstead': 'إنشاء رمز أعطيه بنفسي',
  'platform.code.loggedHint': 'يُسجَّل كل رمز، ويصل صاحبَ الحساب إشعار عند استخدامه.',
  'platform.codes.title': 'سجل رموز التفعيل',
  'platform.codes.subtitle': 'كل رمز أصدرته المنصّة: لمن، ولماذا، وكيف وصل، ومن أصدره، وهل استُخدم.',
  'platform.codes.search': 'ابحث برقم الهاتف أو الاسم',
  'platform.codes.col.time': 'الوقت',
  'platform.codes.col.person': 'الشخص',
  'platform.codes.col.delivery': 'الطريقة',
  'platform.codes.col.issuedBy': 'أصدره',
  'platform.codes.col.state': 'الحالة',
  'platform.codes.state.used': 'استُخدم',
  'platform.codes.state.notSent': 'لم يُرسل',
  'platform.codes.state.expired': 'انتهت صلاحيته',
  'platform.codes.state.active': 'صالح',
  'platform.codes.until': 'حتى',
  'platform.codes.empty': 'لم يُصدر أي رمز بعد',
  'platform.codes.emptyBody': 'تظهر هنا الرموز التي ترسلها أو تعطيها للأشخاص.',
  'platform.codes.end': 'لا توجد رموز أقدم',
  'platform.overview.title': 'نظرة عامة',
  'platform.overview.subtitle': 'حال المنصّة اليوم، وما يحتاج متابعة',
  'platform.overview.schools': 'المدارس',
  'platform.overview.schoolsSub': '{active} فعّالة، {trial} تجريبية',
  'platform.overview.activated': 'حسابات مفعّلة',
  'platform.overview.activatedSub': 'من أصل {n}',
  'platform.overview.activeWeek': 'نشطون هذا الأسبوع',
  'platform.overview.activeWeekSub': 'دخلوا في آخر ٧ أيام',
  'platform.overview.staffSub': 'الموظفون: {n}',
  'platform.overview.attention': 'تحتاج متابعة',
  'platform.overview.attentionHint': 'اشتراكات تنتهي قريباً أو انتهت، ومدارس للقراءة فقط أو موقوفة',
  'platform.overview.allGood': 'لا شيء يحتاج متابعة الآن',
  'platform.overview.lastDay': 'آخر ٢٤ ساعة',
  'platform.overview.activeSchools': 'مدارس نشطة',
  'platform.overview.payments': 'دفعات مسجّلة',
  'platform.overview.attendance': 'علامات حضور',
  'platform.overview.sms': 'رسائل رموز الدخول',
  'platform.overview.smsHint': 'ما أُرسل عبر مزوّدي الرسائل، بطلب الناس أو من لوحة المنصّة',
  'platform.overview.smsToday': 'آخر ٢٤ ساعة',
  'platform.overview.smsMonth': 'آخر ٣٠ يوماً',
  'platform.overview.recentFailures': 'آخر الرسائل التي لم تُرسل',
  'platform.overview.sent': 'أُرسلت: {n}',
  'platform.overview.failed': 'فشلت: {n}',
  'platform.sub.title': 'الاشتراك',
  'platform.sub.hint': 'تصبح المدرسة للقراءة فقط بعد ٧ أيام من انتهاء الفترة المدفوعة أو التجربة، وتعود فعّالة فور تسجيل دفعة.',
  'platform.sub.none': 'بلا موعد انتهاء',
  'platform.sub.paidUntil': 'مدفوع حتى {date}',
  'platform.sub.trialUntil': 'تجربة حتى {date}',
  'platform.sub.endsIn': 'ينتهي خلال {n}',
  'platform.sub.trialEndsIn': 'تنتهي التجربة خلال {n}',
  'platform.sub.endsToday': 'ينتهي اليوم',
  'platform.sub.trialEndsToday': 'تنتهي التجربة اليوم',
  'platform.sub.grace': 'انتهى في {date}، للقراءة فقط من {readOnly}',
  'platform.sub.expired': 'انتهى في {date}',
  'platform.sub.edit': 'تعديل التواريخ',
  'platform.sub.record': 'تسجيل دفعة',
  'platform.sub.plan': 'الباقة',
  'platform.sub.trialEndsAt': 'نهاية التجربة',
  'platform.sub.paidUntilLabel': 'مدفوع حتى',
  'platform.sub.readOnlyNote': 'وضع القراءة فقط يبدأ من {date} ما لم تُسجَّل دفعة.',
  'platform.sub.payments': 'الدفعات',
  'platform.sub.noPayments': 'لم تُسجَّل دفعات بعد',
  'platform.sub.method.TRANSFER': 'تحويل',
  'platform.sub.method.CASH': 'نقداً',
  'platform.sub.method.WALLET': 'محفظة إلكترونية',
  'platform.sub.method.OTHER': 'أخرى',
  'platform.sub.period': 'من {from} إلى {to}',
  'platform.sub.paidOn': 'دُفعت في {date}',
  'platform.sub.recorded': 'سُجّلت الدفعة؛ الاشتراك مدفوع حتى {date}',
  'platform.sub.recordHint': 'دفعة من {name} لاشتراك تباشير. تمدّد الفترة المدفوعة بالمدة المختارة.',
  'platform.sub.recordSubmit': 'تسجيل الدفعة',
  'platform.sub.amount': 'المبلغ',
  'platform.sub.months': 'المدة',
  'platform.sub.methodLabel': 'طريقة الدفع',
  'platform.sub.reference': 'رقم المرجع',
  'platform.sub.paidOnLabel': 'تاريخ الدفع',
  'platform.sub.extendsHint': 'تبدأ الفترة بعد آخر يوم مدفوع إن كان الاشتراك سارياً، أو بعد نهاية التجربة إن كانت جارية، وإلا فمن اليوم. المدرسة التجريبية أو التي للقراءة فقط تصبح فعّالة.',
  'platform.sub.editHint': 'للحالات الخاصة، مثل تمديد تجربة أو تصحيح تاريخ. يُسجَّل كل تعديل.',
  'platform.sub.planHint': 'مثلاً: حتى ٥٠٠ طالب، سنوي',
  'platform.sub.emptyNoEnd': 'اتركه فارغاً إن لم يكن له موعد',
  'platform.sub.notePlaceholder': 'مثلاً: تمديد التجربة أسبوعين',
  'platform.sub.statusSeparate': 'لا يغيّر هذا حالة المدرسة؛ غيّرها من بطاقة الحالة إن لزم.',
  'platform.sub.saved': 'حُفظ الاشتراك',
  'platform.edit.title': 'تعديل البيانات',
  'platform.edit.hint': 'الاسم والشعار واللون كما تظهر في التطبيق والإيصالات.',
  'platform.edit.saved': 'حُفظت بيانات المدرسة',
  'platform.col.lastActivity': 'آخر نشاط',
  'platform.col.lastDay': 'آخر ٢٤ ساعة',
  'platform.activity': 'دفعات: {payments}، حضور: {attendance}',
  'platform.people.title': 'الأشخاص',
  'platform.people.subtitle': 'كل الحسابات في كل المدارس',
  'platform.people.search': 'ابحث برقم الهاتف أو الاسم',
  'platform.people.start': 'ابحث عن شخص',
  'platform.people.startHint': 'اكتب ٣ أرقام على الأقل من الهاتف (بأي صيغة) أو جزءاً من الاسم.',
  'platform.people.noneHint': 'تحقّق من الرقم، أو أضف الشخص إلى مدرسة أولاً.',
  'platform.people.noSchool': 'المنصّة',
  'platform.people.disabled': 'موقوف',
  'platform.people.notActivated': 'لم يُفعَّل',
  'platform.people.back': 'الأشخاص',
  'platform.people.notFound': 'لم يُعثر على هذا الحساب',
  'platform.person.more': 'المزيد',
  'platform.person.rename': 'تصحيح الاسم',
  'platform.person.renameHint': 'يظهر الاسم في كل المدارس التي ينتمي إليها الحساب.',
  'platform.person.signOut': 'تسجيل الخروج من كل الأجهزة',
  'platform.person.disable': 'إيقاف الحساب',
  'platform.person.enable': 'إعادة تفعيل الحساب',
  'platform.person.done.signOut': 'سُجّل الخروج من كل الأجهزة',
  'platform.person.done.disable': 'أُوقف الحساب',
  'platform.person.done.enable': 'أُعيد تفعيل الحساب',
  'platform.person.done.rename': 'صُحّح الاسم',
  'platform.person.confirm.signOut': 'تسجيل خروج {name} من كل الأجهزة؟',
  'platform.person.confirm.disable': 'إيقاف حساب {name}؟',
  'platform.person.confirm.enable': 'إعادة تفعيل حساب {name}؟',
  'platform.person.confirmBody.signOut': 'يلزم الدخول من جديد بكلمة المرور على كل جهاز، خلال ١٥ دقيقة على الأكثر. مفيد عند ضياع هاتف.',
  'platform.person.confirmBody.disable': 'لن يستطيع صاحب الحساب الدخول إلى أي مدرسة، ويُسجَّل خروجه من كل الأجهزة. بياناته في المدارس تبقى كما هي.',
  'platform.person.confirmBody.enable': 'يستطيع صاحب الحساب الدخول من جديد بكلمة مروره.',
  'platform.person.schools': 'المدارس والأدوار',
  'platform.person.noSchools': 'ليس عضواً في أي مدرسة',
  'platform.person.since': 'منذ {date}',
  'platform.person.account': 'الحساب',
  'platform.person.password': 'كلمة المرور',
  'platform.person.passwordSet': 'عُيّنت',
  'platform.person.passwordNotSet': 'لم تُعيَّن بعد',
  'platform.person.lastSeen': 'آخر نشاط',
  'platform.person.sessions': 'أجهزة مسجَّل الدخول عليها',
  'platform.person.created': 'أُنشئ الحساب',
  'platform.person.messages': 'رسائل الرموز',
  'platform.person.messagesHint': 'آخر ١٠ رسائل SMS لهذا الرقم',
  'platform.person.noMessages': 'لم تُرسل رسائل لهذا الرقم',
  'platform.person.msgSent': 'أُرسلت',
  'platform.person.msgFailed': 'لم تُرسل',
  'platform.person.fromConsole': 'من لوحة المنصّة',
  'platform.person.selfService': 'طُلبت من التطبيق',
  'platform.person.codes': 'رموز التفعيل',
  'platform.person.allCodes': 'كل الرموز',
  'platform.person.noCodes': 'لا رموز من لوحة المنصّة',
  'platform.create.subscription': 'الاشتراك',
  'platform.create.trial': 'الفترة التجريبية',
  'platform.create.trialOpen': 'تجربة مفتوحة بلا موعد',
  'platform.create.trialEnds': 'تبدأ التجربة اليوم وتنتهي في {date}. بعدها بسبعة أيام تصبح المدرسة للقراءة فقط إن لم تُسجَّل دفعة.',
  'platform.create.trialNone': 'لن يُحسب وقت: تبقى المدرسة تجريبية حتى تسجّل دفعة أو تحدّد موعداً. مناسب لمدارس التجربة المجانية (Pilot).',
  'platform.sub.noClock': 'لا يُحسب وقت لهذه المدرسة: لا نهاية للتجربة ولا فترة مدفوعة. حدّد نهاية التجربة من «تعديل التواريخ» أو سجّل دفعة.',
  'platform.activate.period': 'مدة التفعيل',
  'platform.activate.until': 'حتى تاريخ',
  'platform.activate.open': 'بلا موعد',
  'platform.activate.openNote': 'لن يُحسب وقت لهذه المدرسة ولن تنتهي أبداً حتى تحدّد تاريخاً أو تسجّل دفعة. ستظهر في «تحتاج متابعة».',
  'platform.activate.paymentHint': 'إن دفعت المدرسة، فالأفضل «تسجيل دفعة» من بطاقة الاشتراك: تحفظ المبلغ وتحدّد الفترة وتفعّل المدرسة معاً.',
} as const;
